import { FindParams } from './find-params';

export interface FindParamsDefault extends FindParams {
  name?: string;
  name_match?: string;
  inactive?: boolean;
  'expand[]'?: string[];
}
